import React from "react";
import "./Footer.css";

import { FaGithub, FaHome, FaLinkedin, FaPhone } from "react-icons/fa";

const Footer = () => {
  return (
    <section className="f-wrapper">
      <div className="flexCenter padding f-contaner">
        <div className="flexColStart left-side">
          <img src="bull-icon_34111.png" alt="No Image" width={50} /> <br />
          <span className="info">
            This is world most affordable quiz <br /> Because it's FREE
          </span>
        </div>
        <div className="flexColStart right-side">
          <span>
            <h2>Information</h2>
          </span>
          <div>
            <FaHome
              size={20}
              style={{ color: "#000000", padding: "0 1rem 0 0" }}
            />
            <span>Jirania, Near NIT</span> <br />
            <FaPhone
              size={20}
              style={{ color: "#000000", padding: "0 1rem 0 0" }}
            />
            <span>7005693827</span>
          </div>

          <hr />
          <div>
            <FaGithub
              size={30}
              style={{ color: "#000000", marginRight: "1rem" }}
            />
            <FaLinkedin
              size={30}
              style={{ color: "#000000", marginRight: "1rem" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
